import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class DetectBrowserServiceService {
    private readonly isBrowser: boolean;

    constructor(@Inject(PLATFORM_ID) platformId: object) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    getInternetExplorerVersion() {
        if (!this.isBrowser) {
            return -1;
        }

        var rV = -1; // Return value assumes failure.

        if (
            navigator.appName == 'Microsoft Internet Explorer' ||
            navigator.appName == 'Netscape'
        ) {
            var uA = navigator.userAgent;
            var rE = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
            if (rE.exec(uA) != null) {
                rV = parseFloat(RegExp.$1);
            } else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            /*check for IE 11*/
                rV = 11;
            }
        }
        return rV;
    }

    areYouIE(): boolean {
        if (!this.isBrowser) {
            return false;
        }

        var iEVersion = this.getInternetExplorerVersion();
        if (iEVersion != -1) {
            let alertText =
                'Leider kann die BIM-SWARM Website nicht im Internet Explorer angezeigt werden. Bitte benutzen Sie einen anderen Browser!';
            alert(alertText);
            return true;
        }
        return false;
    }
}
